import { ResursLoading } from '@resurs-internal/mui';

import useTranslation from '../../../hooks/useTranslation';
import StatusPage from '../StatusPage';

const StatusProcessingPage = () => {
    const translate = useTranslation();
    return (
        <StatusPage
            icon={<ResursLoading size="xl" aria-hidden />}
            title={translate(`page.status-processing.title`)}
            body={translate(`page.status-processing.description`)}
        />
    );
};

export default StatusProcessingPage;
